import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IbCheckinApisComponent } from './ib-checkin-apis.component';
import { IbAccordionContainerComponent } from './components/ib-accordion-container/ib-accordion-container.component';
import { NgReactModule } from '../../react/wrapper/ng-react.module';
import { IbCheckinFormApisComponent } from './components/ib-checkin-form-apis/ib-checkin-form-apis.component';
import { IbOverlayComponent } from './components/ib-overlay/ib-overlay.component';
import { AJSFlightsPassengersUtilsServiceTokenProvider } from '@src/components/services/Utils/bridges/ib-flights-passengers-utils-bridge.service';
import { AJSGetCKICachedInformationServiceTokenProvider } from '@src/app/shared/http-services/pac-prm/bridges/ib-get-cached-information-bridge.service';
import { AJSAcceptObjectsPolicyServiceTokenProvider } from '@src/app/shared/http-services/pacc-pacc/bridges/ib-accept-objects-bridge.service';
import { AJSCheckAncillariesServiceTokenProvider } from '@src/app/shared/services/bridges/ib-check-ancillaries-bridge.service';
import { AJSModalServiceProvider } from '@src/app/shared/services/ib-modal/ib-modal-service-bridge.service';
import { AJSFlightsPassengersServiceTokenProvider } from '@src/components/ib-check-in-flights-passengers/services/bridges/ib-flights-and-passengers-bridge.service';
import { AJSCheckPaymentsServiceTokenProvider } from '@src/components/services/Utils/bridges/ib-check-payments-bridge.service';
import { AJSCommonsAncillariesServiceTokenProvider } from '@src/components/services/Utils/bridges/ib-common-ancillaries-bridge.service';
import { AJSUtilstServiceTokenProvider } from '@src/components/services/Utils/bridges/ib-utils-bridge.service';
import { AJSLocationProvider, AJSRouteProvider, CheckinRedirectionService } from '@src/app/shared/services/ib-utils/ib-checkin-redirection.service';

const downgradedComponents = [IbCheckinApisComponent];

const upgradedProviders = [
    AJSFlightsPassengersUtilsServiceTokenProvider,
    AJSUtilstServiceTokenProvider,
    AJSAcceptObjectsPolicyServiceTokenProvider,
    AJSModalServiceProvider,
    AJSGetCKICachedInformationServiceTokenProvider,
    AJSCheckAncillariesServiceTokenProvider,
    AJSCheckPaymentsServiceTokenProvider,
    AJSFlightsPassengersServiceTokenProvider,
    AJSCommonsAncillariesServiceTokenProvider,
    AJSLocationProvider,
    AJSRouteProvider
];
@NgModule({
    declarations: [...downgradedComponents, IbAccordionContainerComponent, IbCheckinFormApisComponent, IbOverlayComponent],
    imports: [CommonModule, TranslateModule, NgReactModule],
    providers: [
        ...upgradedProviders,
        CheckinRedirectionService
    ]
} )

export class IbCheckinApisModule {
    static components = [...downgradedComponents];
}
